export default __webpack_public_path__ + "static/media/size.fa174e6b.svg";